export default Object.freeze({
  getCityHall: {
    GET: (id) => {
      return `cityhalls/${id}`;
    },
  },
});
